// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"Header_root__CkBg5"};